import * as React from 'react';
import styled from 'react-emotion';
import { get } from '@utils/theme';
const Wrapper = styled('div') `
  overflow-x: auto;
  padding: 2px;

  ${p => p.theme.docz.mq({
    marginBottom: [20, 40],
    maxWidth: ['calc(100vw - 40px)', 'calc(100vw - 80px)', '100%'],
})};
`;
const TableStyled = styled('table') `
  padding: 0;
  table-layout: auto;
  box-shadow: 0 0 0 1px ${get('colors.border')};
  background-color: transparent;
  border-spacing: 0;
  border-collapse: collapse;
  border-style: hidden;
  border-radius: ${get('radii')};
  font-size: 14px;
  color: ${get('colors.tableColor')};
  ${p => p.theme.docz.mq(p.theme.docz.styles.table)};

  & thead {
    color: ${get('colors.theadColor')};
    background: ${get('colors.theadBg')};
  }

  & thead th {
    font-weight: 400;
    padding: 20px 20px;

    &:nth-child(1) {
      ${p => p.theme.docz.mq({
    width: ['20%', '20%', '20%', 'auto'],
})};
    }

    &:nth-child(2) {
      ${p => p.theme.docz.mq({
    width: ['10%', '10%', '10%', 'auto'],
})};
    }

    &:nth-child(3) {
      ${p => p.theme.docz.mq({
    width: ['10%', '10%', '10%', 'auto'],
})};
    }

    &:nth-child(4) {
      ${p => p.theme.docz.mq({
    width: ['10%', '10%', '10%', 'auto'],
})};
    }

    &:nth-child(5) {
      ${p => p.theme.docz.mq({
    width: ['20%', '20%', '20%', 'auto'],
})};
    }
  }

  & tbody td {
    padding: 12px 20px;
    line-height: 2;
    font-weight: 200;
  }

  & tbody > tr {
    display: table-row;
    border-top: 1px solid ${get('colors.border')};
  }

  ${p => p.theme.docz.mq(p.theme.docz.styles.table)};
`;
export const Table = (props) => (React.createElement(Wrapper, null,
    React.createElement(TableStyled, Object.assign({}, props))));
//# sourceMappingURL=data:application/json;base64,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